import { Component } from '@angular/core';
import { DISCLAIMER, WEBSITE_HYPERLINK } from '../../../../helpers/constants';
@Component({
  selector: 'app-disclaimer',
  standalone: true,
  imports: [],
  templateUrl: './disclaimer.component.html',
  styleUrl: './disclaimer.component.css',
})
export class DisclaimerComponent {
  disclaimer: string = DISCLAIMER;
  websiteHyperlink: string = WEBSITE_HYPERLINK;
}
